import { logSuppressedError as E } from "../datadog.helper.js";
import "../../constants/safeStorage.constants.js";
var f = {
  localStorage: /* @__PURE__ */ new Map(),
  sessionStorage: /* @__PURE__ */ new Map()
}, l = /* @__PURE__ */ new Set(), S = /* @__PURE__ */ new Set(), I = (e, t, a) => {
  if (!e.has(t) && e.size >= 200) {
    const c = e.keys().next().value;
    c !== void 0 && e.delete(c);
  }
  e.set(t, a);
}, s = (e) => {
  const { area: t, operation: a, key: c } = e, u = `${t}:${a}:${c ?? ""}`;
  if (!l.has(u)) {
    if (l.size >= 50) {
      const v = l.values().next().value;
      v !== void 0 && l.delete(v);
    }
    l.add(u), E(e.createError ? e.createError() : e.error, {
      source: "safeStorage",
      storageArea: t,
      storageOperation: a,
      ...c ? { storageKey: c } : {}
    }, "warn");
  }
}, i = (e) => {
  try {
    const t = globalThis[e];
    if (t == null || typeof t.getItem != "function") {
      s({
        area: e,
        operation: "resolve",
        createError: () => /* @__PURE__ */ new Error(`${e} is unavailable`)
      });
      return;
    }
    return t;
  } catch (t) {
    s({
      area: e,
      operation: "resolve",
      error: t
    });
    return;
  }
}, p = (e) => {
  const t = f[e], a = (r) => t.has(r) ? t.get(r) : null, c = (r) => {
    const o = i(e);
    if (o) try {
      const n = o.getItem(r);
      return n !== null ? n : S.has(e) ? a(r) : null;
    } catch (n) {
      s({
        area: e,
        operation: "getItem",
        key: r,
        error: n
      });
    }
    return a(r);
  }, u = (r, o) => {
    const n = i(e);
    if (n) try {
      n.setItem(r, o), t.delete(r), S.delete(e);
      return;
    } catch (g) {
      s({
        area: e,
        operation: "setItem",
        key: r,
        error: g
      }), S.add(e);
    }
    I(t, r, o);
  }, v = (r) => {
    const o = i(e);
    if (o) try {
      o.removeItem(r);
    } catch (n) {
      s({
        area: e,
        operation: "removeItem",
        key: r,
        error: n
      });
    }
    t.delete(r);
  }, d = () => {
    const r = i(e);
    if (r) try {
      r.clear();
    } catch (o) {
      s({
        area: e,
        operation: "clear",
        error: o
      });
    }
    t.clear();
  }, h = (r) => {
    const o = i(e);
    if (o) try {
      return o.key(r);
    } catch (n) {
      s({
        area: e,
        operation: "key",
        error: n
      });
    }
    return Array.from(t.keys())[r] ?? null;
  }, m = () => {
    const r = i(e);
    if (r) try {
      return r.length;
    } catch (o) {
      s({
        area: e,
        operation: "length",
        error: o
      });
    }
    return t.size;
  };
  return {
    get length() {
      return m();
    },
    clear: d,
    getItem: c,
    getJson: (r, o) => {
      const n = c(r);
      if (n === null) return o;
      try {
        return JSON.parse(n);
      } catch (g) {
        return s({
          area: e,
          operation: "parse",
          key: r,
          error: g
        }), v(r), o;
      }
    },
    isPersistent: () => i(e) !== void 0,
    key: h,
    removeItem: v,
    setItem: u,
    setJson: (r, o) => {
      try {
        u(r, JSON.stringify(o));
      } catch (n) {
        s({
          area: e,
          operation: "serialize",
          key: r,
          error: n
        });
      }
    }
  };
}, P = p("localStorage"), _ = p("sessionStorage"), z = () => {
  l.clear(), S.clear(), f.localStorage.clear(), f.sessionStorage.clear();
};
export {
  p as createSafeStorage,
  z as resetSafeStorage,
  P as safeLocalStorage,
  _ as safeSessionStorage
};

//# sourceMappingURL=safeStorage.helper.js.map